import * as React from "react";
import { Link, LinkProps } from "react-router-dom";
import styled, { StyledComponentProps } from "styled-components";

const ClickableElement = styled.button`
  align-items: center;
  background: inherit;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: inherit;
  outline: none;
  width: 100%;

  &:active {
    &::before {
      content: "";
      margin-right: 0.1rem;
    }
    &::after {
      content: "";
      margin-left: -0.1rem;
    }
  }
`;

export const ClickableMenuItem = styled(ClickableElement)`
  padding: 0;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

export const ClickableRouterLink = ({ children, ...props }: LinkProps) => (
  <StyledLink {...props}>
    <ClickableElement>{children}</ClickableElement>
  </StyledLink>
);

const StyledAnchor = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const ClickableLink = ({ children, ...props }: StyledComponentProps<"a", any, {}, never>) => (
  <StyledAnchor {...props}>
    <ClickableElement>{children}</ClickableElement>
  </StyledAnchor>
);

export default ClickableElement;
